import { MonthlyReport } from 'model';
import { combineEpics } from 'redux-observable';
import { Epic } from 'redux/modules/types';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { getMonthlyReport } from './actions';

export const getMonthlyReportEpic: Epic = (action$, _, { request }) =>
  action$.pipe(
    filter(isActionOf(getMonthlyReport.request)),
    mergeMap(() =>
      request<MonthlyReport>({
        path: 'users/me/monthly-report',
      }).pipe(
        mergeMap((response) => [getMonthlyReport.success(response)]),
        catchError(() => [getMonthlyReport.failure()]),
      ),
    ),
  );

export default combineEpics(getMonthlyReportEpic);
